// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"328":"fr-messages","583":"en-messages","778":"tr-messages","846":"ko-messages"}[chunkId] || chunkId) + "." + {"328":"913d192a","453":"7ca359f3","583":"f0b20886","778":"4e277069","846":"9bbaecfe"}[chunkId] + ".chunk.js";
};